/**
 * /frontend/src/features/analytics/components/abandonment/AbandonmentTimingHistogram.js
 */

import React from 'react';
import ChartContainer from '../shared/ChartContainer';
import HistogramChart from '../charts/HistogramChart';

/**
 * Histogram of minutes waited before abandoning.
 * @param {{data:Array<{bucket:string,count:number}>}} props
 * @returns {JSX.Element}
 */
const AbandonmentTimingHistogram = ({ data }) => (
  <ChartContainer title="Abandonment Timing" subtitle="Minutes waited before abandoning">
    <HistogramChart data={data} xKey="bucket" yKey="count" />
  </ChartContainer>
);

export default AbandonmentTimingHistogram;

